const initialState = {
  loading: false,
  allStrand: [],
  selectedSubject: null,
};

const strandReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "LOADING_STRAND": {
      return {
        ...state,
        loading: actions.loading,
      };
    }
    case "GET_STRAND_DATA": {
      return {
        ...state,
        loading: actions.loading,
        allStrand: actions.data,
        selectedSubject: actions.id,
      };
    }
    case "CLEAR_DATA": {
      return {
        ...state,
        allStrand: [],
        selectedSubject: null,
      };
    }
    default:
      return state;
  }
};
export default strandReducer;
